import PropTypes from 'prop-types';
import ConfirmationModal from '@uilib/business-components/Modal/ConfirmationModal/ConfirmationModal';

import i18n from 'Services/i18n';
import translateButtonGroup from 'uilib-wrappers/modal/helpers';

export default function ConfirmationModalWrapper(props) {
    return (
        <ConfirmationModal
            {...props}
            testDataLabel="eid-popup"
            message={i18n(props.message)}
            text={i18n(props.text)}
            buttons={translateButtonGroup(props.buttons)}
            buttonsLeft={translateButtonGroup(props.buttonsLeft)}
            onAway={props.onDispose}
            onClose={props.onDispose}
            onKeyEsc={props.onDispose}
        >
            {props.children}
        </ConfirmationModal>
    );
}

ConfirmationModalWrapper.propTypes = {
    onDispose: PropTypes.func.isRequired,
};
